import { useRef } from 'react';

export function useBudget({ dispatch, value, currencyCode }) {
  const ref = useRef(null);

  const onChange = (budget) => {
    dispatch({ type: 'BUDGET_CHANGE', payload: budget });
  };

  const onClear = () => {
    dispatch({ type: 'BUDGET_CLEAR' });
  };

  const clear = () => {
    if (ref.current) {
      ref.current.reset();
    }
  };

  const reset = () => {
    dispatch({ type: 'BUDGET_CLEAR' });
    clear();
  };

  return { value, defaultValue: value, onChange, onClear, ref, reset, clear, currencyCode };
}
